import { MSForm, MSInputField } from './Forms';

export class MSFloatingLabelField extends MSInputField {

    $create() {
        this.m_input_type = this.m_cfig.type.substr(3); // remove 'fl_'
        const $div = $('<div class="form-floating ' + (this.m_cfig.outer_classes ? this.m_cfig.outer_classes : "") + '"></div>');
        const html = this.html();
        $(html).appendTo($div);
        return $div;
    }

    onCreated(iFieldConfig) {
        if (!this.$m_input) {
            this.$m_input = this.$m_element.find('input');
        }
        super.onCreated(iFieldConfig);
    }

    html() {
        let input = '<input type="' + this.m_input_type + '" class="form-control' + (this.m_cfig.classes ? (' ' + this.m_cfig.classes) : "") + '"' + this.html_props() + ' id="ms_form_uid-' + this.m_uid + '" key="' + this.m_cfig.key + '" name="' + this.m_cfig.key + '"';
        //if (this.m_cfig.place_holder) {
        input += ' placeholder="' + (this.m_cfig.place_holder ? this.m_cfig.place_holder : "placeholder") + '"';
        //}
        if (this.m_cfig.disable_autofill) {
            input += ' autocomplete="new-password"';
        }
        if (this.m_cfig.title) {
            //				input += ' title="'+this.m_cfig.title+'"';
        }
        if (this.m_cfig.readonly) {
            input += ' readonly';
        }
        if (this.m_cfig.autofocus) {
            input += ' autofocus';
        }
        if(this.m_cfig.prefix){
            input += ' prefix="'+this.m_cfig.prefix+'"';
        }
        if(this.m_cfig.suffix){
            input += ' suffix="'+this.m_cfig.suffix+'"';
        }

        input += this.validation_props() + '>';
        return this.labeledHtml(input) + this.help_html();
    }

    labeledHtml(iHtml) {
        if (!this.m_cfig.label) {
            return iHtml;
        }
        return iHtml + '<label for="ms_form_uid-' + this.m_uid + '">' + this.label() + '</label>';
    };
}

export class MSFloatingLabelSelect extends MSFloatingLabelField {
    html() {
        let html = '<select class="form-select ' + (this.m_cfig.classes ? (' ' + this.m_cfig.classes) : "") + '"' + this.html_props() + ' id="ms_form_uid-' + this.m_uid + '" key="' + this.m_cfig.key + '" name="' + this.m_cfig.key + '"';
        html += this.validation_props() + '>';
        if (Array.isArray(this.m_cfig.options)) {
            for (const val of this.m_cfig.options) {
                html += '<option value="' + val.value + '">' + htmlent(val.label) + '</option>';
            }
        } else {
            for (const k in this.m_cfig.options) {
                html += `<option value="${k}">` + htmlent(this.m_cfig.options[k]) + `</option>`;
            }
        }
        html += '</select>';
        return this.labeledHtml(html) + this.help_html();
    }

    onCreated(iFieldConfig) {
        if (!this.$m_input) {
            this.$m_input = this.$m_element.find('select');
        }
        super.onCreated(iFieldConfig);
    }

    setValue(iValue) {
        this.m_original_value = iValue;
        this.$m_element.find('select').val(iValue);
    }

    getValue() {
        const res = this.$m_element.find('select').val();
        // Om ne veut pas perdre la valeur si elle n'est pas dans la liste
        return res === null ? this.m_original_value : res;
    }

    setOptions(iValues) {
        const $select = this.$m_element.find('select');
        $select.empty();
        for (const val in iValues) {
            $('<option/>').attr('value', val).text(iValues[val]).appendTo($select);
        }
    }
}

export class MSFloatingLabelTextArea extends MSFloatingLabelField {
    html() {
        let input = '<textarea class="form-control' + (this.m_cfig.classes ? (' ' + this.m_cfig.classes) : "") + '"' + this.html_props() + ' id="ms_form_uid-' + this.m_uid + '" key="' + this.m_cfig.key + '" name="' + this.m_cfig.key + '"';
        //if (this.m_cfig.place_holder) {
        input += ' placeholder="' + (this.m_cfig.place_holder ? this.m_cfig.place_holder : "placeholder") + '"';
        //}
        if (this.m_cfig.readonly) {
            input += ' readonly';
        }
        if (this.m_cfig.autofocus) {
            input += ' autofocus';
        }
        if (this.m_cfig.rows) {
            input += ' style="height: calc(' + (2.25 + this.m_cfig.rows * 1.25) + 'rem + calc(var(--bs-border-width)* 2));"';
        }
        input += this.validation_props() + '></textarea>';
        return this.labeledHtml(input) + this.help_html();
    }

    onCreated(iFieldConfig) {
        if (!this.$m_input) {
            this.$m_input = this.$m_element.find('textarea');
        }
        super.onCreated(iFieldConfig);
    }

    setValue(iValue) {
        this.$m_element.find('textarea').val(iValue);
    }

    getValue() {
        return this.$m_element.find('textarea').val();
    }
}




export class MSFloatingLabelPercentage extends MSFloatingLabelField {
    html() {
        let input = '<input type="number" class="form-control' + (this.m_cfig.classes ? (' ' + this.m_cfig.classes) : "") + '"' + this.html_props() + ' id="ms_form_uid-' + this.m_uid + '" key="' + this.m_cfig.key + '" name="' + this.m_cfig.key + '"';
        //if (this.m_cfig.place_holder) {
        input += ' placeholder="' + (this.m_cfig.place_holder ? this.m_cfig.place_holder : "placeholder") + '"';
        //}

        const decimals = this.m_cfig.decimals ?? 1;
        input += ' step="' + (1 / Math.pow(10, decimals)) + '"';
        const min = (this.m_cfig.min * 100) ?? 0;
        input += ' min="' + min + '"';
        const max = (this.m_cfig.max * 100) ?? 100;
        input += ' max="' + max + '"';


        if (this.m_cfig.title) {
            //				input += ' title="'+this.m_cfig.title+'"';
        }
        if (this.m_cfig.readonly) {
            input += ' readonly';
        }
        if (this.m_cfig.autofocus) {
            input += ' autofocus';
        }
        input += this.validation_props() + '>';
        return this.labeledHtml(input) + this.help_html();
    }

    validate(iValue) {
        let val = parseFloat(iValue);
        if (isNaN(val)) {
            val = 0;
        }
        if (val < 0) {
            val = 0;
        }

        const min = (this.m_cfig.min * 100) ?? 0;
        const max = (this.m_cfig.max * 100) ?? 100;
        if (val < min) {
            val = min;
        }
        if (val > max) {
            val = max;
        }

        if (typeof this.m_cfig.decimals == 'number') {
            const factor = Math.pow(10, this.m_cfig.decimals);
            val = Math.round(val * factor) / factor;
        }

        return val;
    }

    setValue(iValue) {
        if (iValue === undefined && this.m_cfig.delete_if_empty) {
            super.setValue('');
        } else {
            super.setValue(this.validate(100 * iValue));
        }
    }

    getValue() {
        const val = super.getValue();
        if (val === '' && this.m_cfig.delete_if_empty) {
            return val;
        }
        return this.validate(val) / 100;
    }
}

export class MSFloatingLabelMonetary extends MSFloatingLabelField {
    html() {
        let input = '<input type="number" class="form-control' + (this.m_cfig.classes ? (' ' + this.m_cfig.classes) : "") + '"' + this.html_props() + ' id="ms_form_uid-' + this.m_uid + '" key="' + this.m_cfig.key + '" name="' + this.m_cfig.key + '"';
        //if (this.m_cfig.place_holder) {
        input += ' placeholder="' + (this.m_cfig.place_holder ? this.m_cfig.place_holder : "placeholder") + '"';
        //}

        input += ' step="0.01"';
        if (this.m_cfig.min !== undefined) {
            input += ' min="' + (this.m_cfig.min / 100) + '"';
        }
        if (this.m_cfig.max !== undefined) {
            input += ' max="' + (this.m_cfig.max / 100) + '"';
        }

        if (this.m_cfig.title) {
            //				input += ' title="'+this.m_cfig.title+'"';
        }
        if (this.m_cfig.readonly) {
            input += ' readonly';
        }
        if (this.m_cfig.autofocus) {
            input += ' autofocus';
        }
        input += this.validation_props() + '>';
        return this.labeledHtml(input) + this.help_html();
    }

    validate(iValue) {
        let val = parseFloat(iValue);
        if (isNaN(val)) {
            val = 0;
        }
        if (val < 0) {
            val = 0;
        }

        if (this.m_cfig.max !== undefined && val > (this.m_cfig.max / 100)) {
            val = this.m_cfig.max / 100;
        }
        if (this.m_cfig.min !== undefined && val < (this.m_cfig.min / 100)) {
            val = this.m_cfig.min / 100;
        }

        return val;
    }

    setValue(iValue) {
        if (iValue === undefined && this.m_cfig.delete_if_empty) {
            super.setValue('');
        } else {
            super.setValue(this.validate(iValue / 100));
        }
    }

    getValue() {
        const val = super.getValue();
        if (val === '' && this.m_cfig.delete_if_empty) {
            return val;
        }
        return Math.round(this.validate(val) * 100);
    }
}

export class MSFloatingDateField extends MSFloatingLabelField {

    setValue(iValue) {
        if (this.m_cfig.format) {
            iValue = moment(iValue, this.m_cfig.format).format('YYYY-MM-DD');
        }
        super.setValue(iValue);
    }

    getValue() {
        const val = super.getValue();
        if (this.m_cfig.format) {
            return moment(val, 'YYYY-MM-DD').format(this.m_cfig.format);
        }
        return val;
    }
}

export function load() {
    MSForm.registerFieldClass('fl_tel', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_text', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_email', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_url', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_password', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_search', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_date', MSFloatingDateField);
    MSForm.registerFieldClass('fl_month', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_week', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_time', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_datetime-local', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_number', MSFloatingLabelField);
    MSForm.registerFieldClass('fl_select', MSFloatingLabelSelect);
    MSForm.registerFieldClass('fl_textarea', MSFloatingLabelTextArea);
    MSForm.registerFieldClass('fl_percentage', MSFloatingLabelPercentage);
    MSForm.registerFieldClass('fl_monetary', MSFloatingLabelMonetary);
}

